// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f4272fcf","413":"c29a6194","453":"231f798c","782":"668697a3","872":"5f3b6b46"}[chunkId] + ".chunk.js";
};